import React, {PureComponent} from 'react'
import I18n from 'I18n'
import styles from './CompanyDetail.module.scss'
import 'react-table/react-table.css'

import AdminAMList from '../AdminAMList/AdminAMList'
import {formatTimestampToDate} from 'modules/Common/utils'
import {parseCompanyData} from 'modules/Admin/utils'


const I18nLocal = I18n.admin

export class CompanyDetail extends PureComponent {
  componentDidMount() {
    const {match} = this.props
    if (match && match.params.id) {
      this.props.getCompanies(1, [match.params.id])
    }
  }
  calculateDataToRender = () => {
    const {match} = this.props
    if (match && match.params.id) {
      return this.props.companies.records[match.params.id] || {}
    } else {
      return {}
    }
  }

  render() {
    const company = parseCompanyData(this.calculateDataToRender())
    const match = this.props.match

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <span>{company.fullName}</span>
        </div>
        <div className={styles.detail}>
          <hr />
          <div className={styles.input}>
            <div className={styles.property}>{I18nLocal.companyName}</div>
            <div className={styles.value}>{company.fullName}</div>
          </div>
          <hr />
          <div className={styles.input}>
            <div className={styles.property}>{I18nLocal.loginName}</div>
            <div className={styles.value}>{company.name}</div>
          </div>
          <hr />
          <div className={styles.input}>
            <div className={styles.property}>{I18nLocal.location}</div>
            <div className={styles.value}>{company.description}</div>
          </div>
          <hr />
          <div className={styles.input}>
            <div className={styles.property}>{I18nLocal.dateRegistered}</div>
            <div className={styles.value}>{formatTimestampToDate(company.creationTimestamp, 'HH:mm DD/MM/YYYY')}</div>
          </div>
          <hr />
          <div className={styles.input}>
            <div className={styles.property}>{I18nLocal.logo}</div>
            <img src={company.logoUrl} alt='' />
          </div>
          <div className={styles.input}>
            <div className={styles.property}>{I18nLocal.logoLogin}</div>
            <img src={company.loginLogoUrl || company.logoUrl} alt='' />
          </div>
          <div className={styles.input}>
            <div className={styles.property}>{I18nLocal['2faWecomBanner']}</div>
            <img src={company['2faWecomBanner']} alt='' />
          </div>
          <hr />
        </div>
        {Object.keys(company).length > 0 ? (
          <AdminAMList
            companyId={match && match.params && match.params.id}
            companyName={company.fullName}
            isSubScreen
            getAccountManagers={this.props.getAccountManagers}
            accountManagers={this.props.accountManagers}
            companies={this.props.companies}
            getCompanies={this.props.getCompanies}
            isLoadingAccountManagers={this.props.isLoadingAccountManagers}
            error={this.props.error}
            isInvitingAM={this.props.isInvitingAM}
            addOrUpdateAM={this.props.addOrUpdateAM}
            isLoadingCompaniesSuggestion={this.props.isLoadingCompaniesSuggestion}
            companiesSuggestion={this.props.companiesSuggestion}
            getCompaniesSuggestion={this.props.getCompaniesSuggestion}
          />
        ) : null}
      </div>
    )
  }
}

export default CompanyDetail
